import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { API_DATA } from '@frontend/util-api-data';
import { Observable, catchError, throwError } from 'rxjs';
import { CLIENT_DATA } from '@frontend/util-api-data';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class SearchDocumentsService {
  private http = inject(HttpClient);
  private translate = inject(TranslateService);

  private apiData = inject(API_DATA);
  private client = inject(CLIENT_DATA).name;

  searchDocuments(
    categoryId: number,
    language: string,
    filterIds?: number[],
    searchTerm?: string,
    limit?: number,
    page?: number,
    searchType?: string,
    sort?: string,
  ): Observable<any> {
    const url = `${this.apiData.apiURL}api/${this.client}/search/${language}`;

    const body = {
      category_id: categoryId,
      limit: limit ?? 24,
      page: page ?? 1,
      filter_values: filterIds ?? [],
      search_terms: searchTerm ?? '',
      ...(searchType && { search_type: searchType }),
      ...(sort && { sort }),
    };

    return this.http.post(url, body).pipe(
      catchError((error) => {
        console.error('Error fetching search documents:', error);
        return throwError(() => new Error('Failed searching documents'));
      }),
    );
  }

  searchSuggestions(
    searchTerm: string,
    language: string,
    searchContentId?: number | null,
    searchType?: string,
  ): Observable<any> {
    const url = `${this.apiData.apiURL}api/${this.client}/search/${language}?type=suggestion`;

    const body = {
      search_terms: searchTerm,
      ...(searchContentId != null && !searchType && { category_id: searchContentId }),
      ...(searchType && { search_type: searchType }),
    };

    return this.http.post(url, body).pipe(
      catchError((error) => {
        console.error('Error fetching search suggestions:', error);
        return throwError(() => new Error('Failed fetching suggestions'));
      }),
    );
  }
}
